import Vue from 'vue';
const SHOW_FIN_MOV = "_SFM";
const SHOW_CONTACT = "_SC";
const SHOW_CUSTOMER_GROUP_FILE = "_SCGF";
const SHOW_CUSTOMER_GROUP = "_SCG";
const SHOW_MARKET_PLACE = "_SMP";
const SHOW_AGRIBOT = "_ABP";

const EventBus = new Vue();

EventBus.showFinMov = (callback, options = {}) => {
    EventBus.$emit(SHOW_FIN_MOV, {...Object.assign({}, options), callback: callback});
};

EventBus.showContact = (callback, options = {}) => {
    EventBus.$emit(SHOW_CONTACT, {...Object.assign({}, options), callback: callback});
};

EventBus.showCustomerGroupFile = (callback, options = {}) => {
    EventBus.$emit(SHOW_CUSTOMER_GROUP_FILE, {...Object.assign({}, options), callback: callback});
};

EventBus.showCustomerGroup = (callback, options = {}) => {
    EventBus.$emit(SHOW_CUSTOMER_GROUP, {...Object.assign({}, options), callback: callback});
};

EventBus.showMarketPlace = (callback, options = {}) => {
    EventBus.$emit(SHOW_MARKET_PLACE, {...Object.assign({}, options), callback: callback});
};

EventBus.showAgribot = (callback, options = {}) => {
    EventBus.$emit(SHOW_AGRIBOT, {...Object.assign({}, options), callback: callback});
};

export {EventBus,
    SHOW_FIN_MOV,
    SHOW_CONTACT,
    SHOW_CUSTOMER_GROUP_FILE,
    SHOW_CUSTOMER_GROUP,
    SHOW_MARKET_PLACE,
    SHOW_AGRIBOT
}
